import React, {useState} from 'react';
import '../App.css';
import axios from 'axios';
import Promote1 from '../Image/Promote1.png';
import Promote2 from '../Image/Promote2.png'; 
import sponsor from '../icon/icons8-sponsor-64.png';
import {toast} from "react-toastify";


function Sponsor() {
    const [phoneNumber,setPhoneNumber] = useState('');
    const [name,setName] = useState('');
    const [title,setTitle] = useState('');
    const [companyName,setCompanyName] = useState('');
    const [email,setEmail] = useState('');
    const [message,setMessage] = useState('');

    const [data,setData] = useState('');

  function connectPhp(){
    let data = [];
    const url="https://pta-hk.com/sponsorApply.php";
    let fData =new FormData();
    fData.append('phoneNum',phoneNumber);
    fData.append('name',name);
    fData.append('title',title);
    fData.append('companyName',companyName);
    fData.append('email',email);
    fData.append('message',message);

    axios.post(url,fData).then
        (response=>{
            data = response.data;
            setData(data);
            if(data ==="ApplySuccess"){
                toast.success("多謝申請,我們將盡快與閤下聯絡..",{
                position:"top-center",
                });      
            }    
        }).catch((e)=>console.log(e));
      
  }

  //Handle phone change
  const handlePhoneChange=(e)=>{
    const value =e.target.value;
    setPhoneNumber(value);
  };

  //Handle name Change
  const handleNameChange=(e)=>{
    const value =e.target.value;
    setName(value);
  }

  //Handle Title Change
  const handleTitleChange=(e)=>{
    const value =e.target.value;
    setTitle(value);
  }

  //Handle Company Change
  const handleCompanyChange=(e)=>{
    const value =e.target.value;
    setCompanyName(value);
  }

  //Handle Email Change
  const handleEmailChange=(e)=>{
    const value =e.target.value;
    setEmail(value);
  }
  
  //Handle Message Change
  const handleMessageChange=(e)=>{
    const value =e.target.value;
    setMessage(value);
  }


  const handleSubmit = (e)=>{
    e.preventDefault();
    //clean phone number,remove all numerical value 
    const cleanedPhoneNum = phoneNumber.replace(/[^\d]/g, '').slice(0, 8);
    //check the start of number
    //^ start of number
    //[23569] -First digit must be 
    //d{7} -followed by 7 digit
    const valid = /^[23569]\d{7}$/.test(cleanedPhoneNum);
    console.log("Valid PhoneNum", valid);
    
    //valid phone number checked
    if (valid) {
        console.log('valid phone submitted !');
        connectPhp();
    }else{
        toast.error("請輸入有效電話號碼..",{
        position:"top-center",
        });      
        console.log('Please enter a valid telephone number ');
    }      
        
    
     
  };

    return (
    <div className="container">
        <div className="banner-section">
          <a
              href="https://www.pta-hk.com/#/booking" 
              target="_blank"
              rel="nopener noreferrer"
              arial-label="Event"
          >
            <img src={ Promote2 }
                alt="Poker Tournament Association"
                className="bannerImage2"
            />
          </a>
        </div>

        <div className="container-content">
            <div className="registry-content">
                <div className="title">申請成為贊助商 &nbsp;&nbsp;
                    <img src={sponsor}
                      alt="Poker Tournament Association"
                      className="icon"
                    />
                </div>
                <form onSubmit = {handleSubmit} className="booking-form">
                    <div className="booking-form-group">
                         <div className="form-notice">
                            *必須墳寫
                        </div>
                    </div>
                    {/********** Name Input *****/}
                    <div className="booking-form-group">
                          <input
                              required
                              type="text"
                              maxLength={20}
                              id="name"
                              value={name}
                              onChange={handleNameChange}
                                placeholder='姓名*...'
                                style={{
                                  width:'200px',
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  backgroundColor:"#e0e0e0" 
                              }}
                          />
                    </div>
                    {/********** Title Input *****/}
                    <div className="booking-form-group">
                          <input
                              required
                              type="text"
                              maxLength={20}
                              id="title"
                              value={title}
                              onChange={handleTitleChange}
                                placeholder='職位*...'
                                style={{
                                  width:'200px',
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  backgroundColor:"#e0e0e0" 
                              }}
                          />
                    </div>
                    {/********** Company Input *****/}
                    <div className="booking-form-group">
                          <input
                              required
                              type="text"
                              maxLength={20}
                              id="company"
                              value={companyName}
                              onChange={handleCompanyChange}
                                placeholder='公司名稱*...'
                                style={{
                                  width:'200px',
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  backgroundColor:"#e0e0e0" 
                              }}
                          />
                    </div>
                    {/********** Phone Input *****/}
                    <div className="booking-form-group">
                          <input
                              required  
                              type="text"
                              maxLength={9}
                              id="phone"
                              value={phoneNumber}
                              onChange={handlePhoneChange}
                                placeholder='輸入有效電話號碼*...'
                                style={{
                                  width:'200px',
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  backgroundColor:"#e0e0e0" 
                              }}
                          />
                    </div>
                    {/********** Email Input *****/}
                    <div className="booking-form-group">
                          <input
                              required  
                              type="email"
                              maxLength={20}
                              id="email"
                              value={email}
                              onChange={handleEmailChange}
                                placeholder='電郵*...'
                                style={{
                                  width:'200px',
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  backgroundColor:"#e0e0e0" 
                              }}
                          />
                    </div>
                    {/********** Message Input *****/}
                    <div className="booking-form-group">
                          <textarea 
                            id="comment-text" 
                            name="message" 
                            rows="10" 
                            placeholder="補充資料..."
                            value={message}
                            onChange={handleMessageChange}
                            style={{
                                  width:'200px',
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px', 
                                  backgroundColor:"#e0e0e0" 
                            }}  
                            >
                            
                          </textarea>  
                          
                    </div>
                    {/***** Button  ************/}       
                    <div className="booking-form-group">
                          <button type="submit"
                            style={{
                              backgroundColor:'#F01010',
                              color:'#ffffff',
                              padding:'8px 15px',
                              border:'none',
                              borderRadius:'4px',
                              cursor:'pointer',
                              width:'200px',
                              
                            }}
                          >  
                            確認                
                          </button>
                    </div>  
                </form>          
            </div>
        </div>                
            
        <div className="banner-section">
            <img src={ Promote1 }
                alt="Poker Tournament Association"
                className="bannerImage1"
            />
        </div> 
    </div> 
    )
}

export default Sponsor
